package dev.jfronny.zerointerest

import androidx.navigation3.runtime.NavKey
import de.connect2x.trixnity.core.model.EventId
import de.connect2x.trixnity.core.model.RoomId
import kotlinx.serialization.Serializable

@Serializable
sealed class Destination : NavKey {
    @Serializable object LoadingScreen : Destination()

    @Serializable object SelectHomeserver : Destination()

    @Serializable data class SelectLoginMethod(val homeserver: String) : Destination()

    @Serializable object PickRoom : Destination()

    @Serializable data class Room(val roomId: RoomId) : Destination() {
        @Serializable sealed class RoomDestination : NavKey {
            @Serializable object Balance : RoomDestination()

            @Serializable object Transactions : RoomDestination()
        }
    }

    @Serializable data class CreateTransaction(val roomId: RoomId, val templateId: String? = null) : Destination()

    @Serializable data class TransactionDetails(val roomId: RoomId, val transactionId: EventId) : Destination()

    @Serializable object SettingsScreen : Destination()

    @Serializable data class SettleScreen(val roomId: RoomId) : Destination()
}
